var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_88312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12L8 8.5L16 12L8 16L0 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12L8 16L16 12L8 8.5L0 12ZM2.35685 12.0604L8 9.59152L13.6431 12.0604L8 14.882L2.35685 12.0604Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8L8 4.5L16 8L8 12L0 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8L8 12L16 8L8 4.5L0 8ZM2.35685 8.06039L8 5.59152L13.6431 8.06039L8 10.882L2.35685 8.06039Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4L8 0L16 4L8 8L0 4Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_88312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.4786fe5be85a1192bbe8bd6ef3e125b7.svg";
export { ForwardRef as ReactComponent };